// Marketing Kit API, extends affiliateApi with marketing endpoints
const API_URL = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = 'plp_affiliate_session';

async function call(path, opts = {}) {
  const tok = (() => { try { return localStorage.getItem(STORAGE_KEY); } catch { return null; } })();
  const headers = {
    'Content-Type': 'application/json',
    ...(opts.headers || {}),
  };
  if (tok) {
    headers['Authorization'] = `Bearer ${tok}`;
    headers['X-Affiliate-Session'] = tok;
  }
  const res = await fetch(`${API_URL}/api/affiliate/marketing${path}`, {
    method: opts.method || 'GET',
    headers,
    credentials: 'include',
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  let data = null;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const err = new Error(data?.detail || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const marketingAPI = {
  getCopy: (lang) => call(`/copy${lang ? `?lang=${lang}` : ''}`),
  getBanners: () => call('/banners'),
  getShortLinks: () => call('/short-links'),
  createShortLink: (body) => call('/short-links', { method: 'POST', body }),
  deleteShortLink: (slug) => call(`/short-links/${slug}`, { method: 'DELETE' }),
};
